import React from "react";

import { Path } from "lib/build/schema";

interface NodeContextValue {
	path: Path;
}

export const NodeContext = React.createContext<NodeContextValue>({ path: [] });

export const NodeContextProvider: React.FunctionComponent<
	React.PropsWithChildren<NodeContextValue>
> = ({ path, children }) => {
	const { path: parentPath } = React.useContext(NodeContext);
	const ctx = React.useMemo(
		() => ({ path: parentPath.concat(path) }),
		[parentPath, path]
	);
	return <NodeContext.Provider value={ctx}>{children}</NodeContext.Provider>;
};
